import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.tr<ContainerProps>`
  width: 100%;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease;

  &.selected,
  &.selected:hover,
  &.selected:hover td {
    background: #c3cdfd48 !important;
  }

  &:nth-child(odd) {
    background: ${({ theme }) => theme.colors.LIGHT1};
  }

  @media (max-width: 1024px) {
    width: 300%;
  }

  &:last-child {
    border-bottom: none;
  }

  &:last-child > div:first-child {
  }

  &:last-child > div:last-child {
  }

  &:hover {
    background: ${({ theme }) => theme.colors.LIGHT1};
  }

  &:hover td {
    background: ${({ theme }) => theme.colors.LIGHT1};
  }
`;
